import {
  SET_FILES,
  SET_PATH,
  SET_FILE_STRUCTURE,
  SET_LABELS,
  SET_FILE_PATH,
  SET_SELECTED_COMPANY,
  SET_LABEL_STATUS,
  BREADCRUMB_CHANGE,
  SET_FOLDER_PATH,
  SET_CHART_ACCOUNTS,
  SET_CSV_DATA,
  SET_EMAIL_UPLOAD_STATUS,
  SET_COMPANY_ID,
  SET_SELECTED_LABELS,
  SET_GRID_VIEW,
  DOCUMENT_TYPE_CHANGE,
  SET_LINKS_SIDEBAR_OPEN
} from "../constants/actionTypes";

export const setFiles = (files) => {
  return {
    type: SET_FILES,
    files,
  }
}

export const breadCrumbChange = (isBreadcrumbChange) => {
  return {
    type: BREADCRUMB_CHANGE,
    isBreadcrumbChange,
  }
}

export const setPath = (path) => {
  return {
    type: SET_PATH,
    path,
  }
}

export const setFolderPath = (folderPath) => {
  return {
    type: SET_FOLDER_PATH,
    folderPath,
  }
}

export const setFilePath = (filePath) => {
  return {
    type: SET_FILE_PATH,
    filePath,
  }
}

export const setFileTreeStructure = (fileTree) => {
  return {
    type: SET_FILE_STRUCTURE,
    fileTree,
  }
}

export const setLabels = (allLabels) => {
  return {
    type: SET_LABELS,
    allLabels,
  }
}

export const setSelectedLabels = (selectedLabels) => {
  return {
    type: SET_SELECTED_LABELS,
    selectedLabels,
  }
}

export const setSelectedCompany = (selectedCompany) => {
  return {
    type: SET_SELECTED_COMPANY,
    selectedCompany,
  }
}

export const setCompanyId = (companyId) => {
  return {
    type: SET_COMPANY_ID,
    companyId,
  }
}

export const updateLabelStatus = (isLabelUpdated) => {
  return {
    type: SET_LABEL_STATUS,
    isLabelUpdated,
  }
}

export const updateUploadStatusThroughEmail = (isEmailDocumentUpload) => {
  return {
    type: SET_EMAIL_UPLOAD_STATUS,
    isEmailDocumentUpload,
  }
}

export const setChartsAccount = (accounts) => {
  return {
    type: SET_CHART_ACCOUNTS,
    accounts,
  }
}

export const setCsvData = (csvData) => {
  return {
    type: SET_CSV_DATA,
    csvData,
  }
}

export const setGridView = (gridView) => {
  return {
    type: SET_GRID_VIEW,
    gridView,
  }
}

export const hasDocumentTypeChange = (hasDocumentTypeChange) => {
  return {
    type: DOCUMENT_TYPE_CHANGE,
    hasDocumentTypeChange,
  }
}

export const setLinksSidebarOpen = (isLinksSidebarOpen) => {
  return {
    type: SET_LINKS_SIDEBAR_OPEN,
    isLinksSidebarOpen,
  }
}
